export default __webpack_public_path__ + "static/media/wild-west.93791209.svg";